import Header from './Header'
import { links, menuItems } from './config'

const Menu = () => {
  return <Header menuItems={menuItems} />
}

export default Menu
